module.exports = __webpack_public_path__ + "static/main-banner_pink_27_11zon-f60e218fac4a6d71d07075936de75f21.webp";